module.exports = __webpack_public_path__ + "static/sport/login-2.0b0de55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/form/login-2.png
// module id = b6rf
// module chunks = 0